import { j as e } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { faInfoCircle as c } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as h } from "@fortawesome/react-fontawesome";
import { Stack as g, FormControl as l, FormLabel as u, Box as p, Tooltip as x, Input as f, FormHelperText as i, Checkbox as b, Link as y } from "@mui/joy";
import { memo as C } from "react";
import { b as D, C as d } from "../../../../../../../react-hook-form.Du3weLRK.js";
import m from "../../../../DqDatasetSyncControlledInput/DqDatasetSyncControlledInput.js";
import { g as I } from "../../../../../../../index._aEPM5Ps.js";
import S from "../../labels/ConfigurationLabel/ConfigurationLabel.js";
import k from "../../labels/CredentialsLabel/CredentialsLabel.js";
const F = 1e4, q = C(() => {
  const {
    control: n,
    setError: j
  } = D();
  return /* @__PURE__ */ e.jsxs(g, { children: [
    /* @__PURE__ */ e.jsx(S, {}),
    /* @__PURE__ */ e.jsx(m, { label: "Advertiser ID", name: "dv360.advertiserId", placeholder: 'e.g. "1234512345"' }),
    /* @__PURE__ */ e.jsx(m, { label: "Audience name", name: "dv360.displayName", placeholder: 'e.g. "Customer match"' }),
    /* @__PURE__ */ e.jsx(m, { label: "Description", name: "dv360.description", placeholder: 'e.g. "DCR Audience"' }),
    /* @__PURE__ */ e.jsx(d, { control: n, name: "dv360.membershipDurationDays", render: ({
      field: {
        disabled: r,
        value: a = "",
        ...s
      },
      fieldState: {
        error: t
      },
      formState: {
        isSubmitting: o
      }
    }) => /* @__PURE__ */ e.jsxs(l, { disabled: r || o, error: !!t, required: !0, children: [
      /* @__PURE__ */ e.jsxs(u, { children: [
        "Membership duration in days",
        /* @__PURE__ */ e.jsx(p, { ml: 0.5, children: /* @__PURE__ */ e.jsx(x, { title: "The duration in days that an entry remains in the audience after the qualifying event. If the audience has no expiration, set the value of this field to 10000. Otherwise, the set value must be greater than 0 and less than or equal to 540.", children: /* @__PURE__ */ e.jsx(h, { icon: c }) }) })
      ] }),
      /* @__PURE__ */ e.jsx(f, { ...s, disabled: r || o, placeholder: 'e.g. "10000"', slotProps: {
        input: {
          max: F,
          min: 0,
          type: "number"
        }
      } }),
      /* @__PURE__ */ e.jsx(i, { children: t?.message })
    ] }) }, "dv360.membershipDurationDays"),
    /* @__PURE__ */ e.jsx(d, { control: n, name: "dv360.userConsentGiven", rules: {
      validate: (r) => r === !0 || "Please give consent"
    }, render: ({
      field: {
        disabled: r,
        value: a = !1,
        ...s
      },
      fieldState: {
        error: t
      },
      formState: {
        isSubmitting: o
      }
    }) => /* @__PURE__ */ e.jsxs(l, { disabled: r || o, error: !!t, required: !0, children: [
      /* @__PURE__ */ e.jsx(b, { ...s, checked: a, label: "I confirm that I have consent to share this data with Google (required by Google)", disabled: r || o }),
      /* @__PURE__ */ e.jsx(i, { children: t?.message })
    ] }) }, "dv360.userConsentGiven"),
    /* @__PURE__ */ e.jsx(k, {}),
    /* @__PURE__ */ e.jsx(d, { control: n, name: "dv360.credentials", render: ({
      field: {
        disabled: r,
        value: a = "",
        ...s
      },
      fieldState: {
        error: t
      },
      formState: {
        isSubmitting: o
      }
    }) => /* @__PURE__ */ e.jsxs(l, { disabled: r || o, error: !!t, required: !0, children: [
      /* @__PURE__ */ e.jsxs(u, { children: [
        "Service account key in JSON format",
        /* @__PURE__ */ e.jsx(p, { ml: 0.5, children: /* @__PURE__ */ e.jsx(x, { title: /* @__PURE__ */ e.jsxs("span", { children: [
          "Please",
          " ",
          /* @__PURE__ */ e.jsx(y, { href: "https://cloud.google.com/iam/docs/keys-create-delete#creating", rel: "noreferrer", target: "_blank", children: "follow the instructions" }),
          " ",
          "to obtain a service account key"
        ] }), children: /* @__PURE__ */ e.jsx(h, { icon: c }) }) })
      ] }),
      /* @__PURE__ */ e.jsx(f, { ...s, disabled: r || o, slotProps: I((v) => j(s.name, v)) }),
      /* @__PURE__ */ e.jsx(i, { children: t?.message })
    ] }) }, "dv360.credentials")
  ] });
});
q.displayName = "GoogleDV360FormControls";
export {
  q as default
};
//# sourceMappingURL=GoogleDV360FormControls.js.map
